// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"c456447a","453":"c0d157df","613":"f7ad77d3","832":"16f03081"}[chunkId] + ".chunk.js";
};